export default __webpack_public_path__ + "static/media/spinner.74c106a1.svg";